<template>
    <div>
  
      <p>
<h2> 初始化状态数组,显示创建结果 initTrial  ";  </h2>
      </p>
    
      <h3>当前设定日期同步到 </h3>
  
    </div>
  </template>
  <script>



export default {
    data() {
      return  {   r:{
      }}
      },
created:function(){
  //注意回调函数的作用域!!!
  this.$http.get("/da/init_trial").then( (response)=>  {
this.r = response.data

    console.log(response.data)
  })
},

mounted:function(){
  console.log("/da/init_trial ==>   完毕")
}

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  